import { useFormikContext } from 'formik';
import { t } from 'i18next';
import React, { FunctionComponent } from 'react';
import { IMaskInput } from 'react-imask';
import { FormField } from '..';
import { FormFieldPropsBase } from './fieldset.model';

type Type = 'landline' | 'mobile';

const mobileNumberMask = {
  mask: 'd0 000 0000000000',
  definitions: {
    d: /[1-9]/,
  },
};

const landlineNumberMask = {
  mask: '000 000000000000',
};

const masks = {
  mobile: mobileNumberMask,
  landline: landlineNumberMask,
};

export const PhoneNumberFormField: FunctionComponent<FormFieldPropsBase & { type: Type }> = ({
  labelTranslationKey = '',
  placeholderTranslationKey = '',
  fieldName,
  isDisabled,
  type,
}): React.JSX.Element => {
  const { values, setFieldTouched, setFieldValue } = useFormikContext<any>();

  const handleBlur = () => {
    setFieldTouched(fieldName, true, true);
  };

  return (
    <FormField
      type="input"
      name={fieldName}
      testId={fieldName}
      labelText={t(labelTranslationKey)}
      isDisabled={isDisabled}
      render={(fieldProps) => (
        <IMaskInput
          {...fieldProps}
          {...masks[type]}
          value={values[fieldName]}
          className="c-input__input"
          name={fieldName}
          onAccept={(value) => {
            setFieldValue(fieldName, value);
          }}
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          onChange={() => {}}
          unmask
          disabled={isDisabled}
          placeholder={t(placeholderTranslationKey)}
          onBlurCapture={handleBlur}
          overwrite={false}
        />
      )}
    />
  );
};
